import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import {
    ServiceNursingCareDiagnosisCodeGridObject,
} from '@libs/types/src/services/object-type/service/service-nursing-care-diagnosis-code.object';
import { ServiceService } from '../../../../../services/service.service';

interface State {
    serviceNursingCareDiagnosisCodes: ServiceNursingCareDiagnosisCodeGridObject | null,
}

const defaultState: State = {
    serviceNursingCareDiagnosisCodes: null,
};

@Injectable()
export class ServiceNursingDiagnosesPageStore extends ComponentStoreFactory<State> {


    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }

}
